import React, { useEffect, useState } from "react";
import copy from "copy-to-clipboard";
import { useDispatch, useSelector } from "react-redux";
import requiredImg from "../../Images/sp.gif";
import TrainingLink from "../ClientDetail/ProjectPlan/TrainingLink";
import { DisplayMsg } from "../../services/toastService";
import { EMAIL_REGEX } from "../../constants/regex";
import { setUrl } from "../../handlers";
import { setTrainingEvents } from "../../store/reducers/SharedLayoutDataSlice";

const Schedule = (props) => {

  const dispatch = useDispatch();

  const sharedData = useSelector((state) => state.SharedLayoutData);
  const [Errors, setErrors] = useState({
    Invitee: "",
    Email: "",
    Trainer: "",
  });

  const [AddDisable, setAddDisable] = useState(false);

  const [TrainingDetail, setTrainingDetail] = useState({
    Invitee: "",
    Email: "",
    TrainerEmail: sessionStorage.USER,
    TrainerId: sessionStorage.userUUID,
    ScheduleLink: "",
    TrainerEvents: [{ label: "-Select", value: "" }],
  });
  const [AddTraining, setAddTraining] = useState(false);
  let check = true;

  useEffect(() => {
    if (TrainingDetail.TrainerId != null && TrainingDetail.TrainerId !== "") {
      FetchData();
    }
  }, []);

  const FetchData = async () => {
    const EventsArray = [];
    const filter = `&active=true&uuid=${TrainingDetail.TrainerId}`;
    await fetch(setUrl("calendly", "event", true) + filter)
      .then((response) => response.json())
      .then((json) => {
        if (json.status === true) {
          if (json.responseContent != null) {
            const item = {
              label: "-Select-",
              value: "",
            };
            EventsArray.push(item);
            json.responseContent.forEach((eventValue) => {
              const eventDetail = {
                label: eventValue,
                value: eventValue,
              };
              EventsArray.push(eventDetail);
            });
            dispatch(setTrainingEvents(EventsArray));
            setTrainingDetail((trainingData) => ({
              ...trainingData,
              TrainerEvents: json.responseContent,
            }));
          }
        } else if (
          json.Message ===
          "Cannot perform runtime binding on a null reference"
        ) {
          setAddDisable(true);
          DisplayMsg("2", "UUId Does not exist..");
        }
      })
      .catch((error) => {
        DisplayMsg("2", "Failed to load trainer");
      });
  };

  const AddNewTraining = async (e, type) => {
    const { name } = e.target;
    const { value } = e.target;

    ValidateField(name, value);

    if (type === "Invitee") {
      const AlphabetRegex = /^[A-Za-z ]*$/;
      if (AlphabetRegex.test(value) || value === "") {
        setTrainingDetail((trainingData) => ({
          ...trainingData,
          [name]: value,
        }));

        setErrors((errorInfo) => ({
          ...errorInfo,
          [e.target.name]: value.length > 0 ? "" : "Required",
        }));
      }

      else if (!AlphabetRegex.test(value) && value !== "") {
        setErrors((errorInfo) => ({
          ...errorInfo,
          [e.target.name]: "Only Alphabets are allowed",
        }));
      }


    } else {
      setTrainingDetail((trainingData) => ({
        ...trainingData,
        [name]: value,
      }));
    }
  };

  const ValidateField = (fieldName, fieldVal) => {
    if (fieldVal.length < 1) {
      setErrors((errorInfo) => ({
        ...errorInfo,
        [fieldName]: "Required",
      }));
    } else if (fieldName === "Email") {
      setErrors((errorInfo) => ({
        ...errorInfo,
        [fieldName]: EMAIL_REGEX.test(fieldVal) ? "" : "❌ Email is not valid!",
      }));
    } else {
      setErrors((errorInfo) => ({
        ...errorInfo,
        [fieldName]: "",
      }));
      check = true;
    }
  };

  const GenerateLink = (event) => {
    VerifyTrainingField();
    if (check) {
      if (
        sessionStorage.userUUID === "" ||
        sessionStorage.userUUID.length < 3
      ) {
        DisplayMsg("2", "Please set UUID first to Create Schedule Meeting...");
      } else if (event.target.value === "Copy") {
        copy(TrainingDetail.ScheduleLink);
      } else {
        setAddTraining(true);
      }
    }
  };

  const VerifyTrainingField = () => {
    let result = "";
    for (const plan in TrainingDetail) {
      if (plan === "Invitee" || plan === "Email") {
        if (TrainingDetail[plan].length < 1) {
          setErrors((errorInfo) => ({
            ...errorInfo,
            [plan]: "Required",
          }));
          check = false;
        } else if (plan === "Email") {
          if (TrainingDetail[plan].length < 1) {
            setErrors((errorInfo) => ({
              ...errorInfo,
              [plan]: "Required",
            }));
            check = false;
          } else if (EMAIL_REGEX.test(TrainingDetail.Email)) {
            result = "";
          } else {
            result = "❌ Email is not valid!";
            check = false;
          }
          setErrors((errorInfo) => ({
            ...errorInfo,
            Email: result,
          }));
        }
      }
    }
  };

  const HandleSetTraining = (childData, link) => {
    setTrainingDetail((trainingData) => ({
      ...trainingData,
      ScheduleLink: link,
    }));
    setAddTraining(childData);
  };

  return (
    <>
      {AddTraining && (
        <TrainingLink
          CallBackLink={HandleSetTraining}
          data={{
            InviteeEmail: TrainingDetail.Email,
            Trainer: TrainingDetail.TrainerEmail,
            TrainerUuid: TrainingDetail.TrainerId,
            Events: sharedData.trainingEvents,
            Invitee: TrainingDetail.Invitee,
          }}
        />
      )}

      <div className="errorMsgPanel" />
      <div className="successMsgPanel" />

      <div
        className={`overlay ${AddTraining === true ? "d-none" : "-webkit-inline-box"
          }`}
      >
        <div className="popup">
          <div className="popup__header">
            <h3>Schedule Meeting </h3>
            <span
              className="close"
              role="button"
              onClick={() => props.changeLoad(false)}
            >
              ×
            </span>
          </div>

          <div className="content flex align-items-center">
            <div className="popup__body">
              <div className="row">
                <div className="col-md-6 col-sm-6 mt-2">
                  <div className="field-container mb-0">
                    <label className="field-placeholder font-medium">
                      {" "}
                      Invitee Email :{" "}
                      <img
                        alt="Required"
                        src={requiredImg}
                        className="redboxRequired"
                      />
                    </label>
                    <input
                      type="text"
                      name="Email"
                      className="field-input"
                      onChange={(e) => AddNewTraining(e)}
                      value={TrainingDetail.Email}
                      maxLength={55}
                    />
                  </div>
                  <label className="requiredtext mt-0">{Errors.Email}</label>
                </div>

                <div className="col-md-6 col-sm-6 mt-2">
                  <div className="field-container mb-0">
                    <label className="field-placeholder font-medium">
                      Invitee :{" "}
                      <img
                        alt="Required"
                        src={requiredImg}
                        width={4}
                        className="redboxRequired"
                      />
                    </label>
                    <input
                      type="text"
                      name="Invitee"
                      className="field-input"
                      onChange={(e) => AddNewTraining(e, "Invitee")}
                      value={TrainingDetail.Invitee}
                      maxLength={55}
                    />
                  </div>
                  <label className="requiredtext mt-0">{Errors.Invitee}</label>
                </div>

                <div className="col-md-6 col-sm-6 mt-2">
                  <div className="field-container mb-0">
                    <label className="field-placeholder font-medium">
                      Trainer :{" "}
                      <img
                        alt="Required"
                        src={requiredImg}
                        className="redboxRequired"
                      />
                    </label>
                    <input
                      type="text"
                      className="field-input"
                      name="TrainerEmail"
                      onChange={(e) => AddNewTraining(e, "trainerEmail")}
                      value={TrainingDetail.TrainerEmail}
                      readOnly
                      disabled
                    />
                  </div>
                  <label className="requiredtext mt-0">{Errors.Trainer}</label>
                </div>

                <div className="col-md-6 col-sm-6 mt-2">
                  <div className="field-container mb-0">
                    <label className="field-placeholder font-medium">
                      Schedule Link
                    </label>
                    <input
                      type="text"
                      onChange={(e) => AddNewTraining(e)}
                      name="ScheduleLink"
                      className="field-input text-overflow-clip"
                      value={TrainingDetail.ScheduleLink}
                      disabled
                    />
                  </div>
                </div>

                {TrainingDetail.TrainerId != null &&
                  TrainingDetail.TrainerId !== "" && (
                    <div className="row text-center mt-4">
                      <div className="col-md-12 col-sm-12">
                        <label>&nbsp;</label>
                        <input
                          type="button"
                          className="btnLinkGreen ClosePopup"
                          disabled={AddDisable}
                          onClick={(event) => GenerateLink(event)}
                          value={
                            TrainingDetail.ScheduleLink.length > 1
                              ? "Copy"
                              : "Add"
                          }
                        />
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Schedule;
